import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

const diseaseList = (props) => {

	return (
		<DataTable
			value={props.diseases}
			paginator={true}
			lazy={true}
			rows={props.rows}
			totalRecords={props.totalRecords}
			onPage={(event) => props.onPageClick(event)}
			first={props.first}
			dataKey='medicineId'
		//loading={props.isLoading}	
		>
			<Column field="diseaseCode" header="Disease Code" style={{ textAlign: "center", width: "12em" }} />
			<Column
				header="Name"
				body={(rowData, column) =>
					rowData && rowData.diseaseContent && rowData.diseaseContent.length ?
						rowData.diseaseContent.map(r => r.diseaseName).join(' / ')
						: null
				}
			/>

			<Column
				header="Actions"
				style={{ textAlign: "center", width: "8em" }}
				body={(rowData, column) =>
					<div>
						<Button
							type="button"
							icon="pi pi-pencil"
							className="p-button-warning"
							tooltip="Edit"
							tooltipOptions={{ position: 'top' }}
							style={{ marginRight: ".5em" }}
							onClick={() => props.editClick(rowData.diseaseId)}
						/>
						<Button
							type="button"
							icon="pi pi-trash"
							className="p-button-danger"
							tooltip="Delete"
							tooltipOptions={{ position: 'top' }}
							onClick={() => props.deleteClick(rowData.diseaseId)}
						/>
					</div>
				}
			/>
		</DataTable>
	)
}

export default diseaseList;
